import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import ProductsAttributesTable from '../../components/ProductsAttributesTable';

/**
 * Bulk Editor Tab
 *
 * Integrated bulk taxonomy editor for managing product attributes across the catalog.
 * Reuses the production-ready ProductsAttributesTable component which provides:
 *
 * Features:
 * - Inline editing of canonical_type, skill_level, brew_focus
 * - Search and filter (by status, review state)
 * - Pagination (50 products per page)
 * - Auto-save with visual feedback
 * - Quality indicators (products needing review)
 * - Support for 50+ granular canonical types
 *
 * How to use:
 * 1. Search or filter to find products
 * 2. Click any dropdown to edit taxonomy override
 * 3. Changes save automatically
 * 4. Use filters to find products needing review
 */
export default function BulkEditorTab() {
  return (
    <Box sx={{ py: { xs: 2, sm: 3 } }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" gutterBottom>
          Bulk Taxonomy Editor
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Edit taxonomy attributes for multiple products. Changes are saved automatically.
        </Typography>
      </Box>

      <Alert severity="info" sx={{ mb: 3 }}>
        <strong>Tip:</strong> Use the "Needs review" filter to find products missing canonical types.
        Set overrides to improve taxonomy quality and enable better product relations.
      </Alert>

      {/* Reuse existing ProductsAttributesTable component */}
      <ProductsAttributesTable />
    </Box>
  );
}
